import { BaseDataChannel } from "./BaseDataChannel";

export class MeshChannel extends BaseDataChannel {
  public onMessage(ev: MessageEvent): void {
    const data = ev.data as ArrayBuffer;
    // Process the mesh data here
    // console.log('Received mesh data of length:', data.byteLength);
    this.emit("data", data);
  }
  public getConfiguration() {
    return {
      name: "mesh",
    };
  }
  protected onConnected(): void { }
}